(()=>{
  const calc=document.getElementById("km-calculator");
  if(calc){
    const title=calc.querySelector(".kmcalc-copy h3");
    const intro=calc.querySelector(".kmcalc-copy p");
    const note=calc.querySelector(".kmcalc-copy>small");
    if(title)title.textContent="CALCOLA IL COSTO IN BASE A GIORNI E KM";
    if(intro)intro.textContent="Seleziona date e orari, scegli il furgone reale dalla foto e indica i chilometri totali previsti.";
    if(note)note.textContent="Stima indicativa. Ogni giorno include 150 km. Il totale viene arrotondato per eccesso alla decina di euro.";
  }

  const guide=document.getElementById("size-guide");
  if(guide){
    const heading=guide.querySelector("h3");
    const lede=guide.querySelector(".lede");
    if(heading)heading.textContent="SCEGLI LA CATEGORIA, POI IL FURGONE REALE";
    if(lede)lede.textContent="Le lunghezze sono indicative di categoria. La misura esatta del singolo mezzo viene confermata prima del noleggio.";
    const cards=[...guide.querySelectorAll(".size-choice")];
    const texts=[
      "Categoria compatta · circa 2,50 m. Scegli poi il mezzo dalla foto.",
      "Categoria media · circa 3,30 m. Scegli poi il mezzo dalla foto.",
      "Categoria grande · fino a circa 3,70 m. Scegli poi il mezzo dalla foto.",
      "Categoria centinata · circa 4,10 m. Scegli poi il mezzo dalla foto."
    ];
    cards.forEach((card,i)=>{const p=card.querySelector("p");if(p&&texts[i])p.textContent=texts[i];});
  }

  document.querySelectorAll(".hero-quote-cta,.booking-step a[href='#preventivo'],.mobilebar a[href='#preventivo']").forEach(link=>{
    link.addEventListener("click",()=>{if(typeof window.gtag==="function")window.gtag("event","preventivo_cta_click",{posizione:link.classList.contains("mobilebar")?"mobile":"pagina"});});
  });
})();
